import { useQuery, useMutation } from '@tanstack/react-query';

import { useActiveContext } from '../auth/contexts/ActiveOrgContext';
import { useAuth } from '../auth/contexts/AuthenticationContext';
import { REPORTS_OWN_ERRORS } from '../../shared/api/callSiteErrors';

import { billingApi } from './endpoints';

export type {
  BillingData, BillingCharge, BillingSubscription, BillingPaymentMethod, BillingRegistration,
} from './endpoints';

export function useBilling() {
  const { isAuthenticated } = useAuth();
  const { active } = useActiveContext();

  return useQuery({
    queryKey: ['billing', active.kind, active.kind === 'org' ? active.orgId : null],
    queryFn: billingApi.get,
    enabled: isAuthenticated,
  });
}

export function useOpenBillingPortal() {
  return useMutation({
    mutationFn: () => billingApi.portal(),
    // BillingPage is the only call site and renders the failure inline, naming
    // which button was pressed and what is therefore still unchanged.
    meta: REPORTS_OWN_ERRORS,
    onSuccess: (data) => {
      window.location.href = data.url;
    },
  });
}
